import PlainteRow from "./PlainteRow";
import "../../styles/table.css";

export default function PlainteTable({ plaintes, onView }) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Utilisateur</th>
            <th>Sujet</th>
            <th>Message (Aperçu)</th>
            <th>Statut</th>
            <th className="center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {plaintes && plaintes.length > 0 ? (
            plaintes.map((plainte) => (
              <PlainteRow
                key={plainte.id}
                plainte={plainte}
                onView={onView}
              />
            ))
          ) : (
            <tr>
              <td colSpan="5" className="emptyTable">
                Aucune plainte reçue pour le moment
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}